import React from 'react';
import WorkspaceFilter from './components/WorkspaceFilter/WorkspaceFilter';
import DurationFilter from './components/DurationFilter/DurationFilter';
import AllFilter from './components/AllFilter/AllFilter';
import BudgetFilter from './components/BudgetFilter/BudgetFilter';

const SideFilters = ({ onWorkspaceHandler, handleDurationSelection, fetchData }: any) => {
  return (
    <>
      <BudgetFilter fetchData={fetchData} />
      <WorkspaceFilter onWorkspaceHandler={onWorkspaceHandler}/>
      <DurationFilter handleDurationSelection={handleDurationSelection} />
      <AllFilter fetchData={fetchData} />
    </>
  )
}

export default SideFilters;